import {
  IPolizaVitalicia,
  IDatosContratanteProducto,
} from 'src/app/shared/Entities/entities';
import { Subscription } from 'rxjs';
import { Component, OnInit, Input } from '@angular/core';
import { PersonService } from 'src/app/shared/services/person.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { setLocalStorage } from '../../../../shared/helpers/helper';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';

@Component({
  selector: 'app-card-asegurado-vitalicia',
  templateUrl: './card-asegurado.component.html',
  styleUrls: ['./card-asegurado.component.sass'],
})
export class CardAseguradoComponent implements OnInit {
  @Input() idPoliza: string;
  @Input() tipoSeguro = '';
  @Input() numPersona = '';
  @Input() lineaNegocio = '';

  loading = false;
  error = false;
  datosAsegurado: IPolizaVitalicia;
  datoContratante: IDatosContratanteProducto;
  respcertificado: any;
  is_SolicitudCert: boolean;
  casebyid: string;
  thiscasebyid: string;
  errorSC = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private productService: ProductService,
    private personService: PersonService,
    private productSrv: ProductService,
    private appInsightsService: AppInsightsService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.error = false;
    this.productService
      .getDetalleVitalicia(this.idPoliza, this.tipoSeguro, this.numPersona)
      .subscribe(data => {
        this.loading = false;
        this.datosAsegurado = data;
      });

    this.personService
      .getDatosContratanteProducto(
        this.idPoliza,
        this.lineaNegocio,
        this.tipoSeguro
      )
      .subscribe(data => {
        this.datoContratante = data;
      });
  }

  completeCaseCertificateid(completerespC: any) {
    this.is_SolicitudCert = true;
    this.thiscasebyid = completerespC;
  }

  expandChange() {
    this.appInsightsService.trackEvent(Event.pidsAccShowContractor);
  }
}
